export default __webpack_public_path__ + "static/media/Vorlage-Fahrzeugverwaltung.1306aaf4.csv";